import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { DateTimeField, FunctionField, ImageField, TextField } from 'shared/react-admin/Fields';
import { ReferenceField } from 'shared/react-admin/ReferenceFields';
import { MethodLogosShowDialog } from 'shared/widgets/MethodLogosShowDialog/MethodLogosShowDialog';
import { MethodLogo } from 'types/embedded/methodLogo';

export const MethodsShowTable: React.FC = () => {
  const translate = useTypedTranslate();
  const { hasResourceAccess } = usePermissions();
  const { record, handleOpenRecordModal, openRecordModal, handleCloseRecordModal } =
    useRecordModal<MethodLogo>();

  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '136px' } } }}>
      <TableRowWrapper label={translate('app.table.alias')}>
        <TextField source="alias" />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.createdAt')}>
        <DateTimeField inline source="createdAt" />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.table.updatedAt')}>
        <DateTimeField inline source="updatedAt" />
      </TableRowWrapper>
      {hasResourceAccess(Resources.MethodLogos) && (
        <TableRowWrapper label={translate('app.table.logo')}>
          <ReferenceField
            empty={EMPTY_FIELD}
            link={false}
            reference="method_logos"
            source="logo.@id"
          >
            <FunctionField
              render={(record: MethodLogo) => (
                <ImageField
                  onClick={() => handleOpenRecordModal(record)}
                  source="filePath"
                  sx={{
                    cursor: 'pointer',
                    '& .RaImageField-image': {
                      maxWidth: 48,
                      minWidth: 48,
                      minHeight: 'auto',
                      margin: 0,
                      objectFit: 'contain',
                    },
                  }}
                />
              )}
            />
          </ReferenceField>
        </TableRowWrapper>
      )}
      {record && (
        <MethodLogosShowDialog
          methodLogo={record}
          onClose={handleCloseRecordModal}
          open={openRecordModal}
        />
      )}
    </CardTable>
  );
};
